<template>
    <div class="menu-container" :style="computedIsFixed">
      <div class="menu-header" v-if="!isArchiveModule">
        <a v-if="!isArchiveModule" class="btn-add" @click="onShowAddModal"><i class="fa fa-plus" aria-hidden="true"></i>添加模块</a>
        <a v-if="!isSort" class="button is-primary fright" @click="toggleSort">排序</a>
        <a v-else @click="toggleSort" class="button is-success fright">保存</a>
      </div>
      <div class="fashion-menu-wrap box" >
        <div class='fashion-menu'>
          <draggable v-model="list" :move="noMove">
            <div class="menu-item"
                v-for="(item, index) in list"
                :class="{'is-active':item.isSelected}"
                @click="toggleActive(index)">
              <i v-if="isSort" class="fa fa-bars" aria-hidden="true"></i>
              <span class="module-title" :title="item.title">{{item.title}}</span>
              <span class="tag module-type" :class="getModuleType(item.moduleType).bgColor">{{getModuleType(item.moduleType).title}}
                <span v-if="!item.status && !isArchiveModule" class="off-tag">关</span>
              </span>
            </div>
          </draggable>
        </div>
      </div>
      <div class="menu-footer">
        <button v-if="!isArchiveModule" class="button is-link" @click="getArchiveModule">查看已归档版块</button>
        <button v-else  @click="getList" class="button is-link">返回</button>
      </div>
      <el-dialog title="添加模块" :visible.sync="modal.visible">
        <div class="modal-wrap">
          <div class="block">
            <label class="label">可配置模块</label>
            <button class="button is-warning" @click="onAddModule(0)">热区图模块</button>
            <button class="button is-primary" @click="onAddModule(1)">横滑图模块</button>
            <button class="button is-success" @click="onAddModule(2)">轮播图模块</button>
          </div>
          <div class="block">
            <label class="label">系统模块</label>
            <button class="button is-dark" v-for="module in sysModule"  @click="onAddModule(module.moduleType)">{{module.name}}</button>
          </div>
        </div>
      </el-dialog>
    </div>
</template>
<script type="text/babel">
  import { mapState, mapActions } from 'vuex';
  import draggable from 'vuedraggable';

  export default {
    components:{ draggable },
    watch: {
      updateFashionMenu(){
        if(!this.updateFashionMenu){
          return false;
        }
        this.isArchiveModule ? this.getArchiveModule() : this.getList();
      }
    },
    data(){
      return {
        list:[],
        isSort:false,
        isArchiveModule:false,
        sysModule:[//系统模块 0:热区1:横滑2:轮播 3:系统-全民搭配师4:系统-猜搭配 5:系统-视频学穿搭6:系统-干货笔记
          {
            moduleType:3,
            name:'全民搭配师'
          },
          {
            moduleType:4,
            name:'猜搭配'
          },
          {
            moduleType:5,
            name:'视频学穿搭'
          },
          {
            moduleType:6,
            name:'干货笔记'
          },
          {
            moduleType:7,
            name:'店铺关注'
          },
		  {
			moduleType:9,
			name:'穿搭手册'
		  }
        ],
        modal:{
          visible:false,
        }
      }
    },
    computed:{
      ...mapState({
          updateFashionMenu : state => state.updateFashionMenu,
          currentFashionMenu: state => state.currentFashionMenu
      }),
      computedIsFixed(){
        if(!this.modal.visible){
          return {
            "position":"fixed"
          }
        }else {
          return {}
        }
      }
    },
    props:{
      /**
       * 0:市集
       * 1:发现
       */
      type:{
        type:Number,
        default:0,
        require:true
      }
    },
    mounted(){
      this.getList();
    },
    methods: {
      ...mapActions([
        'setCurrentFashionMenuByVuex'
      ]),
      noMove(evt){
        return evt.draggedContext.index!==this.list.length-1
      },
      getList(){
        HttpRequest.get('/admin.php?method=fashion.getModuleList',{type:this.type}).then(response => {
          this.isArchiveModule = false;
          this.list = _.toArray(response.data.list)
          this.initSelectedItem()
        })
      },
      toggleActive(index){
        let list = JSON.parse(JSON.stringify(this.list))
        _.each(list,item => {
          item.isSelected = false;
        })
        list[index].isSelected = true
        this.list = list;
        this.setCurrMenuState(index)
      },
      toggleSort(){
        this.isSort = !this.isSort;
        let moduleIds = [],
            params = {};
        if(!this.isSort){//进行排序保存
          _.each(this.list,item => {
            moduleIds.push(item.moduleId)
          })
          params = {
            type:this.type,
            moduleIds:moduleIds
          }
          HttpRequest.post('/admin.php?method=fashion.doSaveModuleSort',params).then(response => {
            if(response.data.success){
              this.$message("保存成功！")
            }
          })
        }
      },
      /**
       * 获取已归档模块
       */
      getArchiveModule(){
        HttpRequest.get('/admin.php?method=fashion.getArchiveModuleList',{type:this.type}).then(response => {
          this.isArchiveModule = true
          this.list = _.toArray(response.data.list)
          this.initSelectedItem()
        })
      },
      initSelectedItem(){
        let currentIndex = 0;
        if(this.currentFashionMenu.moduleId){
          let tag = false;
          _.each(this.list,(item,index) => {
            if(item.moduleId == this.currentFashionMenu.moduleId){
              item.isSelected = true;
              currentIndex = index;
              tag = true;
            }else {
              item.isSelected = false;
            }
          })
          if(!tag){//当前没有vuex中的module
            _.each(this.list,(item,index) => {
              if(index == currentIndex){
                item.isSelected = true;
              }else {
                item.isSelected = false;
              }
            })
          }
        }else {
          _.each(this.list,(item,index) => {
            if(index == currentIndex){
              item.isSelected = true;
            }else {
              item.isSelected = false;
            }
          })
        }
        this.setCurrMenuState(currentIndex)
      },
      setCurrMenuState(index = 0){
        let name = "",
            query = {}
        if(!this.list.length){
          return false;
        }
        query = {
          type:this.type,
          moduleType:this.list[index].moduleType,
          moduleId:this.list[index].moduleId,
          moduleName:this.list[index].title
        }
        this.setCurrentFashionMenuByVuex(query)
        if(this.type === 0){
          name = "market"
        }else if(this.type === 1){
          name = "discovery"
        }
        this.$router.push({
          name:name,
          query:query
        })
      },
      onShowAddModal(){
        this.modal.visible = true
      },
      /**
       * 添加模块
       */
      onAddModule(moduleType){
        let query = {
          type:this.type,
          moduleType:moduleType
        }
        let name = ""
        this.setCurrentFashionMenuByVuex(query)
        if(this.type === 0){
          name = "market"
        }else if(this.type === 1){
          name = "discovery"
        }
        this.$router.push({
          name:name,
          query:query
        })
        let list = JSON.parse(JSON.stringify(this.list))
        _.each(list,item => {
          item.isSelected = false;
        })
        this.list = list;
        this.modal.visible = false;
      },
      /**
       * 模块描述
       * @param moduleType
       * 0:热区1:横滑2:轮播3:系统-全民搭配师4:系统-猜搭配5:系统-视频学穿搭6:系统-干货笔记
       */
      getModuleType(moduleType){
        let confModuleList = { //可配置模块
          0:{
            title:"热区",
            bgColor:"is-warning"
          },
          1:{
            title:"横滑",
            bgColor:"is-primary"
          },
          2:{
            title:"轮播",
            bgColor:'is-success'
          },
        }
        if(confModuleList[moduleType]){
          return confModuleList[moduleType]
        }else {
          return {
            title:"系统",
            bgColor:'is-dark'
          }
        }
      }
    },
    filters:{

    }
  }
</script>
<style lang="less">
  .menu-container {
  .menu-header {
    margin-bottom: 10px;
    height: 30px;
    .btn-add {
      text-align: center;
      color:#ed6c63;
      cursor: pointer;
      position: relative;
      top:10px;
      .fa {
        margin-top: 3px;
        margin-right: 5px;
      }
    }
  }
.fashion-menu-wrap{
  padding: 10px 5px 10px 10px;
  width: 200px;
  box-sizing: border-box;
  z-index: 5000;
  max-height: 70vh;
  overflow-y: scroll;
  overflow-x: hidden;
  .fashion-menu {
    min-height: 75vh;
    .menu-item {
      padding: 10px 0px;
      font-size: 16px;
      border-radius: 3px;
      cursor: pointer;
      font-weight: bold;
      .fa {
        margin-top: 3px;
        margin-right: 5px;
      }
      .module-type {
        position: relative;
        .off-tag {
          position: absolute;
          top: -6px;
          right: -6px;
          color:#dd1144;
        }
      }
      .module-title {
        display: inline-block;
        max-width: 95px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
    }
    .tag {
      margin-left: 5px;
    }
    .is-active {
      color:#42afe3;
    }

  }
  ul[dnd-list] .dndDragging{
    opacity: 0.7;
  }
  ul[dnd-list] .dndDraggingSource {
    display: none;
  }
  ul[dnd-list] .dndPlaceholder {
    display: block;
    background-color: #eee;
    height: 30px;
  }
}
  .menu-footer {
    position: relative;
    .button {
      position: absolute;
      bottom: -15px;
      right: -15px;
    }
  }
  .modal-wrap {
    .button {
      margin-right: 20px;
    }
  }
  .modal-ct-foot {
    div {
      display: none;
    }
  }
  }
</style>
